export default "<div class=\"search-field\">\r\n    <pplus-input-text #input [(ngModel)]=\"value\" [closable]=\"true\"></pplus-input-text>\r\n</div>\r\n"